/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sso_Select_Organization_SubtitleInputs */



/**
* | output |
* | --- |
* | "Select which organization you'd like to access" |
*
* @param {Auth_Sso_Select_Organization_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_select_organization_subtitle = /** @type {((inputs?: Auth_Sso_Select_Organization_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_Select_Organization_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle die Organisation aus, auf die du zugreifen möchtest")
	return /** @type {LocalizedString} */ ("Select which organization you'd like to access")
});